import { render, staticRenderFns } from "./DocTemplateForm.vue?vue&type=template&id=7947eb0f"
import script from "./DocTemplateForm.vue?vue&type=script&lang=js"
export * from "./DocTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7947eb0f')) {
      api.createRecord('7947eb0f', component.options)
    } else {
      api.reload('7947eb0f', component.options)
    }
    module.hot.accept("./DocTemplateForm.vue?vue&type=template&id=7947eb0f", function () {
      api.rerender('7947eb0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/wps/DocTemplateForm.vue"
export default component.exports